import React, { useEffect, useState } from "react"
import Tooltip from "./tooltip"
import { DuplicateIcon } from "./icons-svg"
import copyToClipboard from "copy-to-clipboard"
import store from "../store"
import { requestJSON } from "../utils/request-module"
/**
 * @param props {{address:string,shorten?:boolean,disableCopy?:boolean,showNames?:boolean}}
 */
export default function AddressDisplay({ address = "",shorten=false,disableCopy=false,showNames=false}) {
  var name = '';
  if(showNames && store.getSelectedSimulationAddressListArr().length && address) {
    let addressObj = store.getSelectedSimulationAddressListArr().find((item) => (item.address?.toLowerCase?.() == address?.toLowerCase?.()));
    if(addressObj){
      name=addressObj.name;
    }
    // console.log("name", name);
    shorten=true
  }
  if(!address) return <span>None</span>
  var defaultCopyTip="Copy to clipboard"
  var [copyTip,setCopyTip]=useState(defaultCopyTip)
  //@ts-ignore
  if(address?.type=="choose") {
    //@ts-ignore
    address=store.addresses[address.chosenValue ]
  }
  function shortenedAddress(address) {
    if(!shorten) return address
    if(shorten && address.length<8) return address
    return <>
      <Tooltip
      tip={address}
      >
      {address?.slice?.(0, 4)}
      <span >...</span >
      {address?.slice?.(-2)}
      </Tooltip>
    </>
  }
  function copy(){
    copyToClipboard(address)
    setCopyTip("Copied!")
    setTimeout(()=>{
      try { // in timeout might be an error of updating unmounted component
        setCopyTip(defaultCopyTip)
      } catch(err) {
        const noop=function(){}
        noop() // eslint don't allow empty blocks
      }
    },2000)
  }
  return (
    <span css={`white-space:nowrap;`}>
      {!name && shortenedAddress(address)}
      {name && <span>{name} ({shortenedAddress(address)})</span>}
      <Tooltip tip={copyTip}>
        <span onClick={copy} css={`@media print {visibility:hidden;}; visibility:${disableCopy ? 'hidden':'visible'};`}>
          {DuplicateIcon()}
        </span>
      </Tooltip>
      <ShowContractName address={address} />
    </span >
  )
}
export function ShowContractName({address}){
  var name=useContractName(address)
  if(!name) return null
  return <span>({name})</span>
}

var addressNames=[
]

function useContractName(address){
  var [name,setName]=useState('')
  useEffect(()=>{
    var cancel
    (async()=>{
      var res
      if(!address || address.length!=42) {
        setName('')
        return
      }
      if(addressNames[address]) {
        res=addressNames[address]
      } else {
        res=requestJSON('GET','/get-address-name?address=' + address,undefined,true)
        addressNames[address]=res
      }
      var resName=(await res)?.name
      if(resName) {
        setName(resName)
      }
    })()
    if(cancel) return
    return ()=>{
      cancel=true
    }
  },[address])
  return name
}

export async function getNameFromAddress(address) {
  if(!address || address.length!=42) {
    return ''
  }
  var res=await requestJSON('GET','/get-address-name?address=' + address,undefined,true)
  return res?.name
}